import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import banner from '@/assets/background.png'

const HeroSection = () => {
    return (
        <section
            className="h-[600px] flex items-center justify-center text-white"
            style={{
                backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${banner})`,
                backgroundSize: 'cover',
                backgroundPosition: 'bottom',
                height: '350px'
            }}
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-heading font-bold leading-tight mb-6 text-red">
                    Welcome to Axent Brokers Ltd<br className="hidden md:block" />
                </h1>
                <p className="text-xl max-w-2xl mx-auto mb-8 ">
                    The easiest way to quote, compare, and place insurance
                </p>
                <p className="text-lg max-w-2xl mx-auto mb-8">
                    We give brokers instant access* to a panel of trusted insurers - fast quotes, flexible options, and support when you need it
                </p>
            </div>
        </section>
    );
};

export default HeroSection;
